import React, {Component} from 'react';
import '../App.css';
import * as firebase from "firebase";
import 'firebase/auth';
import 'firebase/database';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Home from "./Home";
import TopBar from "../components/TopBar";
import NotFound from "./NotFound";
import D3PrintHome from "./D3PrintHome";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {firebase: null};
  }

  render() {
    return (
      <div className="App">
        <TopBar/>
        <Router>
          <Switch>
            <Route exact path="/" component={Home}/>
            <Route exact path="/3dprint" component={D3PrintHome}/>
            <Route component={NotFound}/>
          </Switch>
        </Router>
      </div>
    );
  }

  componentWillMount() {
    //init Firebase
    this.initFirebase();
  }

  initFirebase() {
    try {
      // Initialize Firebase
      let config = {
        apiKey: "AIzaSyCbYjtZ3P-TuYdyb68YyZ79RipgG6Th6VU",
        authDomain: "frankkienl-broniesnl.firebaseapp.com",
        databaseURL: "https://frankkienl-broniesnl.firebaseio.com",
        projectId: "frankkienl-broniesnl",
        storageBucket: "frankkienl-broniesnl.appspot.com",
        messagingSenderId: "397704792981"
      };
      firebase.initializeApp(config);
      //
      //let firebaseApp = firebase.app();
      const firestore = firebase.firestore();
      console.log("Firebase loaded");
      //Let state know Firebase is loaded
      this.setState({
        firebase: {loaded: true}
      });
      //Add auth listener
    } catch (e) {
      console.error(e);
    }
  }

}

export default App;
